let loadScript = require('./loadScript');

module.exports = class Captcha {
  constructor(elem) {
    this.elem = elem;

    this.renderPromise = new Promise((resolve, reject) => {
      this.renderPromiseResolve = resolve;
      this.renderPromiseReject = reject;
    });

    this.render();
  }

  async render() {
    if (!window.CAPTCHA_ID) return;

    // console.log('RENDER');
    
    if (this.widgetId !== undefined) return; // already rendered

    await loadScript();

    let container = document.createElement('div');
    this.elem.append(container);

    this.widgetId = window.CAPTCHA_TYPE == 'recaptcha' ? grecaptcha.render(container, {
      sitekey: window.CAPTCHA_ID,
      size: 'invisible',
      callback: this.renderPromiseResolve,
    }) : smartCaptcha.render(container, {
      sitekey: window.CAPTCHA_ID,
      hl: 'ru',
      invisible: true,
      hideShield: true,
      test: true,
      callback: this.renderPromiseResolve
    });;

    // console.log('RENDERED', this.widgetId);
  }

  async execute() {
    if (!window.CAPTCHA_ID) return '';
    await this.render();

    let captchaApi = CAPTCHA_TYPE == 'recaptcha' ? grecaptcha : smartCaptcha;

    let token = captchaApi.getResponse(this.widgetId);

    // console.log("TOKEN", token);

    if (token) {
      // already resolved
      return token;
    }

    // prevent body scroll while modal captcha is open
    // document.body.classList.add('overflow-hidden');
    // this.renderPromise.then(() => document.body.classList.remove('overflow-hidden'));

    captchaApi.execute(this.widgetId);

    // console.log('EXECUTED', this.widgetId);
    return this.renderPromise;
  }

  async validateForm(form) {
    if (!window.CAPTCHA_ID) return;

    let token = await this.execute();

    // console.log("VALIDATE TOKEN", token);
    let input = form.elements['captcha-response'];
    if (!input) {
      input = document.createElement('input');
      input.name = 'captcha-response';
      input.type = 'hidden';
      form.append(input);
    }

    input.value = token;
  }
};
